import styled from 'styled-components';

export const Container = styled.span`
  position: relative;
  display: inline-flex;

  .updates-bell-button {
    cursor: pointer;
    font-size: 12px;
    padding: 4px 6px;

    .material-icons {
      font-size: 14px;
    }
  }

  .updates-bell-tooltip {
    position: absolute;
    bottom: calc(100% + 6px);
    left: 0;
    z-index: 10;
    padding: 4px 8px;
    border-radius: 4px;
    background: ${(props) => props.theme.$charcoal};
    color: ${(props) => props.theme.$white};
    font-size: 12px;
    line-height: 1.3;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.15s ease;
  }

  .updates-bell-button:hover + .updates-bell-tooltip,
  .updates-bell-button:focus + .updates-bell-tooltip {
    opacity: 1;
    visibility: visible;
  }
`;
